export const en = {
  common: {
    login: "Sign in",
    logout: "Sign out",
    register: "Sign up",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    back: "Back",
    next: "Next",
    submit: "Submit",
    confirm: "Confirm",
    close: "Close",
    search: "Search",
    loading: "Loading...",
    open: "Open",
    download: "Download",
    upload: "Upload",
    view: "View",
    yes: "Yes",
    no: "No",
    status: "Status",
    created: "Created",
    updated: "Updated",
    actions: "Actions",
    profile: "Profile",
    settings: "Settings",
    notifications: "Notifications",
    messages: "Messages",
    documents: "Documents",
    home: "Public home",
    dashboard: "Dashboard",
    none: "None",
    all: "All",
  },
  nav: {
    how_it_works: "How it works",
    solutions: "Solutions",
    why_cxoora: "Why CXOORA",
    for_companies: "For companies",
    for_managers: "For managers",
    faq: "FAQ",
    free_checkup: "Take the free check-up",
    go_to_dashboard: "Go to dashboard",
    apply_to_network: "Apply to the network",
  },
  hero: {
    badge: "Leadership as a Service",
    title_main: "The manager you need.",
    title_accent: "Only for the time you need.",
    subtitle: "CXOORA helps SMEs and growing companies access experienced managers without having to hire a full-time executive. We find the most suitable professional, define goals, and measure results.",
    cta_primary: "Find out which manager you need",
    cta_secondary: "Talk to an expert",
    cta_note: "The first check-up is free and takes just a few minutes.",
    flexibility: "A senior expertise can enter your company a few days a month, one or two days a week, or for a specific project.",
    journey: "The CXOORA journey",
    journey_steps: {
      need: { label: "Needs analysis", value: "Free check-up" },
      selection: { label: "Manager selection", value: "Max 3 shortlist" },
      project: { label: "Project activated", value: "Milestones & timeline" },
      kpi: { label: "KPI tracked", value: "Real time" },
      results: { label: "Results", value: "Measurable" },
    },
    apply: "Apply to the network",
  },
  sections: {
    problem_badge: "The problem",
    problem_title: "Your company is growing, but you can't handle it all alone.",
    solution_badge: "The solution",
    solution_title: "Large-company expertise, accessible to your SME too.",
    before_after_title: "From a hard-to-manage problem to a clear path.",
    before: "Before",
    with_cxoora: "With CXOORA",
    how_works_badge: "How it works",
    how_works_title: "A simple journey. Concrete support.",
    benefits_badge: "Why CXOORA",
    benefits_title: "A concrete solution for companies that want to take a leap forward.",
    audience_title: "CXOORA is designed for your company if…",
    comparison_title: "Why choose a fractional formula?",
    final_cta_title_main: "You don't always need to hire a new executive.",
    final_cta_title_accent: "You need to find the right one.",
    final_cta_subtitle: "Complete the free check-up. We'll help you understand which managerial skill can generate the most value in your company.",
  },
  footer: {
    tagline: "The right leadership, when you need it.",
    description: "Fractional Management platform for Italian SMEs.",
    service: "Service",
    resources: "Resources",
    legal: "Legal",
    privacy: "Privacy Policy",
    cookie: "Cookie Policy",
    terms: "Terms & Conditions",
    ethics: "Code of ethics",
    rights: "All rights reserved. Demo MVP.",
  },
  auth: {
    welcome_back: "Welcome back",
    welcome_subtitle: "Access your private area.",
    email: "Email",
    password: "Password",
    no_account: "No account yet?",
    have_account: "Already have an account?",
    demo_accounts: "Demo accounts (Demo2025!)",
    admin_label: "Admin",
    company_label: "Company",
    manager_label: "Manager",
    create_account: "Create an account",
    register_subtitle: "Choose registration type and complete the fields.",
    company_name: "Company name",
    full_name: "Full name",
    phone_optional: "Phone (optional)",
    password_hint: "Password (min 6 characters)",
    terms_consent: "By registering you accept our",
    and: "and the",
    forgot_password: "Forgot password?",
  },
  dashboard: {
    overview: "Overview",
    company_profile: "Company profile",
    checkup: "Check-up",
    requests: "Requests",
    shortlist: "Shortlist",
    meetings: "Meetings",
    proposals: "Proposals",
    projects: "Projects",
    invoices: "Invoices",
    availability: "Availability",
    opportunities: "Opportunities",
    referrals: "Referrals",
    companies: "Companies",
    managers: "Managers",
    applications: "Applications",
    matching: "Matching & Shortlist",
    calls: "Calls",
    packages: "Packages",
    analytics: "Analytics",
    audit_log: "Audit log",
    welcome_user: "Welcome, {{name}}",
    activity_overview: "Here is an overview of your activity.",
    suggested_actions: "Suggested actions",
    recent_notifications: "Recent notifications",
    recent_requests: "Your recent requests",
    no_notifications: "No notifications",
    see_all: "See all",
  },
  shortlist: {
    title: "Your shortlists",
    subtitle: "Browse the managers selected for you. Compare up to 3 profiles.",
    match_score: "Match score",
    request_call: "Request call",
    profile_btn: "Profile",
    compare: "Compare managers",
    no_shortlist: "You don't have a shortlist available yet. The CXOORA team is working on your selection.",
    download_pdf: "Download PDF",
  },
  project: {
    timeline: "Timeline",
    milestones: "Milestones",
    kpi: "KPIs",
    tasks: "Tasks",
    time_entries: "Hours/Days",
    feedback: "Feedback",
    progress: "Progress",
    company: "Company",
    manager: "Manager",
    package: "Package",
    duration: "Duration",
    objective: "Objective",
    scope: "Scope",
    download_report: "Download PDF report",
  },
  settings: {
    account: "Account",
    change_password: "Change password",
    current_password: "Current password",
    new_password: "New password",
    update_password: "Update password",
    language: "Language",
    google_connect: "Connect Google Calendar",
    google_connected: "Connected as",
    google_disconnect: "Disconnect",
    google_not_configured: "Google integration not yet configured by admin",
  },
  referrals: {
    title: "Your referrals",
    subtitle: "Invite other senior managers to the CXOORA network. You'll receive recognition when the referral is approved.",
    invite_new: "Invite a manager",
    referee_name: "Candidate name",
    referee_email: "Candidate email",
    referee_role: "Target role (optional)",
    note: "Notes (optional)",
    send_invite: "Generate invite",
    invite_link: "Invite link",
    copy_link: "Copy link",
    link_copied: "Link copied",
    no_referrals: "You haven't sent any referrals yet.",
    status_pending: "Pending",
    status_invited: "Invited",
    status_submitted: "Application submitted",
    status_approved: "Approved",
    status_rejected: "Rejected",
  },
};
